import { ActivityIndicator } from 'react-native';

import { tokens } from '../../tokens';

import type { ButtonSize, ButtonType } from './types';

type ButtonActivityIndicatorProps = {
  size: ButtonSize;
  type: ButtonType;
  disabled?: boolean;
};

const buttonSizeToIndicatorSize = {
  xs: 15,
  sm: 18,
  md: 21,
  lg: 24,
  xl: 24,
};

export function ButtonActivityIndicator(props: ButtonActivityIndicatorProps) {
  let color: string = tokens.colors.$houseRed;

  switch (props.type) {
    case 'solid':
    case 'outline-inverted':
      color = tokens.colors.$white;
      break;
    case 'solid-inverted':
    case 'ghost':
    case 'outline-subtle':
      color = tokens.colors.$houseDark;
      break;
  }

  if (props.disabled) {
    color =
      props.type === 'outline-inverted'
        ? tokens.colors.$whiteOpacity30
        : tokens.colors.$disabledText;
  }

  return <ActivityIndicator size={buttonSizeToIndicatorSize[props.size]} color={color} />;
}
